export default "__VITE_ASSET__62e30010__"